import type { BasePaginationDto } from '@@types/api.types';
import { Button } from '@components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@components/ui/select';
import React from 'react';

type AdminLlmPaginationProps = {
  isFetching?: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onLimitChange: (limit: number) => void;
  pagination: BasePaginationDto;
};

export const AdminLlmPagination: React.FC<AdminLlmPaginationProps> = (props) => {
  const { isFetching, onPreviousPage, onNextPage, onLimitChange, pagination } = props;

  const { page, limit, totalItems, totalPages, hasPreviousPage, hasNextPage } = pagination;
  const displayPageNumber = totalItems === 0 ? 0 : page;
  const totalPagesLabel = totalItems === 0 ? 0 : totalPages;
  const displayStart = totalItems === 0 ? 0 : (page - 1) * limit + 1;
  const displayEnd = totalItems === 0 ? 0 : Math.min(page * limit, totalItems);

  return (
    <div className="flex flex-col gap-2 border-t px-4 py-3 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
        <div className="flex items-center gap-2">
          <span>Results per page:</span>
          <Select
            value={limit.toString()}
            onValueChange={(value) => onLimitChange(Number(value))}
          >
            <SelectTrigger className="h-8 w-auto text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="25">25</SelectItem>
              <SelectItem value="50">50</SelectItem>
              <SelectItem value="75">75</SelectItem>
              <SelectItem value="100">100</SelectItem>
            </SelectContent>
          </Select>
          <span>of {totalItems} results</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          disabled={!hasPreviousPage || isFetching}
          onClick={onPreviousPage}
          size="xs"
          variant="outline"
        >
          Previous
        </Button>
        <span>
          Page {displayPageNumber} of {totalPagesLabel}
        </span>
        <Button
          disabled={!hasNextPage || isFetching}
          onClick={onNextPage}
          size="xs"
          variant="outline"
        >
          Next
        </Button>
      </div>
    </div>
  );
};
